export default "__VITE_ASSET__DZ8uMgVN__"